"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var operators_1 = require("rxjs/operators");
/**
 * @deprecated moved to skynet-store-currency-api
 */
function getDefaultCurrency(store) {
    return skynet_store_currencies_api_1.currencyStoreManager.selectAll(store).pipe(operators_1.filter(function (value) { return !value.isEmpty(); }), operators_1.map(function (currencies) {
        return currencies.valueSeq().find(function (currency) { return currency.isDefault; });
    }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, Error("Can't find default currency")));
}
exports.getDefaultCurrency = getDefaultCurrency;
function createLogger(namespace) {
    return new skynet_store_utilities_1.Logger('skynet-store-currencies-impl', namespace);
}
exports.createLogger = createLogger;
//# sourceMappingURL=currency.utilities.js.map